// TODO update this to import from commons
// import { gql } from '@reverbdotcom/commons/src/gql';
// eslint-disable-next-line no-restricted-imports
import { gql } from '@apollo/client';
import React from 'react';
import I18n from 'i18n-js';

import { formatInternationalizedSeconds } from '../lib/date_utils';
import { Item2FeedbackItemData, core_apimessages_Feedback_Type as FeedbackType } from '@reverbdotcom/commons/src/gql/graphql';

import { RCStarRating } from '@reverbdotcom/cadence/components';
import SanitizedRender from '@reverbdotcom/commons/src/components/sanitized_render';

const TRUNCATION_LIMIT = 300;

interface IProps {
  feedback: Item2FeedbackItemData.Fragment;
}

function FeedbackMessage(props: IProps) {
  if (!props.feedback.message) return null;

  return (
    <p
      data-item2-feedback-message
      className="mb-0 mt-2 size-90"
    >
      <SanitizedRender
        truncationLimit={TRUNCATION_LIMIT}
        html={props.feedback.message}
        htmlTag="span"
      />
    </p>
  );
}

function FeedbackResponse(props: IProps) {
  const { response } = props.feedback;
  if (!response) return null;

  const responseDate = formatInternationalizedSeconds(response.createdAt.seconds, 'LL');

  return (
    <div
      className="bd-1 bd-primary bg-offwhite bg--lighten padding-2 mt-4"
      data-item2-feedback-response
    >
      <p className="mb-2">
        <SanitizedRender
          truncationLimit={TRUNCATION_LIMIT}
          html={response.body}
          htmlTag="span"
        />
      </p>
      <div
        className="size-90 opacity-70"
        data-item2-feedback-response-meta
      >
        {I18n.t(
          'discovery.shop.feedback.byline',
          {
            date: responseDate,
            name: props.feedback.recipient.shortname,
          },
        )}
      </div>
    </div>
  );
}

function FeedbackTitle({ feedback }: IProps) {
  if (feedback.type === FeedbackType.BUYER) {
    return null;
  }

  return (
    <div
      className="d-block weight-bold mt-1"
    >
      {feedback.orderTitle}
    </div>
  );
}

export default function Item2FeedbackItem(props: IProps) {
  const { feedback } = props;

  return (
    <div className="ptb-2 bdt-1 bd-primary">
      <RCStarRating hideTooltip rating={feedback.rating / 5}  />
      <FeedbackTitle feedback={feedback} />
      <div
        data-item2-feedback-review-meta
        className="size-80 opacity-70"
      >
        {I18n.t(
          'discovery.item2FeedbackItem.byline',
          {
            date: formatInternationalizedSeconds(feedback.createdAt.seconds, 'LL'),
            name: feedback.author.shortname,
          },
        )}
      </div>
      <FeedbackMessage feedback={feedback} />
      <FeedbackResponse feedback={feedback} />
    </div>
  );
}

export const Item2FeedbackItemFragment = gql`
  fragment Item2FeedbackItemData on core_apimessages_Feedback {
    author {
      _id
      shortname
    }
    createdAt {
      seconds
    }
    message
    orderTitle
    rating
    recipient {
      _id
      shortname
    }
    listingLink {
      href
    }
    response {
      body
      createdAt {
        seconds
      }
    }
    type
  }
`;
